import React from "react";
import { getEndCustomers } from "../../../API/swesum";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import EndCustomersTable from "./components/EndCustomerTable";
import MainLayout1 from "Components/UI/Layout/MainLayout1";

export function Endcustomers() {
  const navigate = useNavigate();

  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Slutkunder</Typography>
          <Button
            onClick={() => navigate("create")}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            SKAPA NY
          </Button>
        </Box>
        <EndCustomersTable />
      </MainLayout1>
    </>
  );
}
